/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, NETWORLD){
	const a = 'is-active';
	const makerIndex = () => {
		if($('.js-support-maintenance-maker-json').length) {
			const getJSON = (_code) => {
				return $.getJSON(`/ajax/support/maintenance/maker.json?p_maker=${_code}`);
			};
			for (let i = 0; i < $('.js-support-maintenance-maker-json').length; i++) {
				getJSON($('.js-support-maintenance-maker-json').eq(i).find('.js-maker-title-code').text()).done((data) => {
					// console.log(data,'data');
					let HTML = '';
					for (let l = 0; l < data.rt_bn_support_maintenance.length; l++) {
						let remarks ='';
						if(data.rt_bn_support_maintenance[l].cf_n_remarks) {
							remarks = '<p class="color_gray2 mt20">'+data.rt_bn_support_maintenance[l].cf_n_remarks+'</p>';
						}
						let link = '<a href="#" class="di_block" style="pointer-events:none; cursor:default; text-decoration:none;">';
						if(!(data.rt_bn_support_maintenance[l].rt_cf_n_href_support.href === '#')) {
							link = '<a href="'+data.rt_bn_support_maintenance[l].rt_cf_n_href_support.href+'" target="'+data.rt_bn_support_maintenance[l].rt_cf_n_href_support.target+'" class="di_block opacity">';
						}
						let products = '';
						if(data.rt_bn_support_maintenance[l].cf_n_products) {
							products = '<ul class="mod-list01">'+
							'<li><span class="_label">対象製品</span></li>'+
							'<li><span class="color_gray2">'+data.rt_bn_support_maintenance[l].cf_n_products+'</span></li>'+
							'</ul>';
						}
						let work_description = '';
						if(data.rt_bn_support_maintenance[l].cf_n_work_description) {
							work_description = '<ul class="mod-list01">'+
							'<li><span class="_label _green">作業内容</span></li>'+
							'<li><span class="color_gray2">'+data.rt_bn_support_maintenance[l].cf_n_work_description+'</span></li>'+
							'</ul>';
						}
						HTML += '<div class="pt40 pb20 mod-borderBottom">'+
						link+
						'<p class="fw_bold fs_18 fs_md_16 cf_n_title">'+data.rt_bn_support_maintenance[l].cf_n_title+'</p>'+
						'<div class="pure-g mod-spaceU pt40">'+
						'<div class="pure-u-1-2 pure-u-lg-1-1 pure-u-md-1-1 mod-spaceU-child">'+
						products+
						'</div>'+
						'<div class="pure-u-1-2 pure-u-lg-1-1 pure-u-md-1-1 mod-spaceU-child">'+
						work_description+
						'</div>'+
						'</div>'+
						remarks+
						'</a>'+
						'</div>';
					}
					$('.js-support-maintenance-maker-json-item').eq(i).append(HTML);
				});
			}
			$('.js-support-maintenance-maker-json')
		}
		if($('.js-support-introduction-maker-json').length) {
			const getJSON = (_code) => {
				return $.getJSON(`/ajax/support/introduction/maker.json?p_maker=${_code}`);
			};
			for (let i = 0; i < $('.js-support-introduction-maker-json').length; i++) {
				getJSON($('.js-support-introduction-maker-json').eq(i).find('.js-maker-title-code').text()).done((data) => {
					console.log(data,'data');
					let HTML = '';
					for (let l = 0; l < data.rt_bn_support_introduction.length; l++) {
						let remarks ='';
						if(data.rt_bn_support_introduction[l].cf_n_remarks) {
							remarks = '<p class="color_gray2 mt20">'+data.rt_bn_support_introduction[l].cf_n_remarks+'</p>';
						}
						let link = '<a href="#" class="di_block" style="pointer-events:none; cursor:default; text-decoration:none;">';
						if(!(data.rt_bn_support_introduction[l].rt_cf_n_href_support.href === '#')) {
							link = '<a href="'+data.rt_bn_support_introduction[l].rt_cf_n_href_support.href+'" target="'+data.rt_bn_support_introduction[l].rt_cf_n_href_support.target+'" class="di_block opacity">';
						}
						let products = '';
						if(data.rt_bn_support_introduction[l].cf_n_products) {
							products = '<ul class="mod-list01">'+
							'<li><span class="_label">対象製品</span></li>'+
							'<li><span class="color_gray2">'+data.rt_bn_support_introduction[l].cf_n_products+'</span></li>'+
							'</ul>';
						}
						let work_description = '';
						if(data.rt_bn_support_introduction[l].cf_n_work_description) {
							work_description = '<ul class="mod-list01">'+
							'<li><span class="_label _green">作業内容</span></li>'+
							'<li><span class="color_gray2">'+data.rt_bn_support_introduction[l].cf_n_work_description+'</span></li>'+
							'</ul>';
						}
						HTML += '<div class="pt40 pb20 mod-borderBottom">'+
						link+
						'<p class="fw_bold fs_18 fs_md_16 cf_n_title">'+data.rt_bn_support_introduction[l].cf_n_title+'</p>'+
						'<div class="pure-g mod-spaceU pt40">'+
						'<div class="pure-u-1-2 pure-u-lg-1-1 pure-u-md-1-1 mod-spaceU-child">'+
						products+
						'</div>'+
						'<div class="pure-u-1-2 pure-u-lg-1-1 pure-u-md-1-1 mod-spaceU-child">'+
						work_description+
						'</div>'+
						'</div>'+
						remarks+
						'</a>'+
						'</div>';
					}
					$('.js-support-introduction-maker-json-item').eq(i).append(HTML);
				});
			}
			$('.js-support-introduction-maker-json')
		}
	};
	makerIndex();

})(window.jQuery, window.NETWORLD);
